<template>
  <div class="container">
    <div style="margin-bottom: 20px">
      <el-input prefix-icon="el-icon-search" clearable v-model="searchText" style="width: 260px"></el-input>
      <el-button style="margin-left: 10px" @click="loadData">查询</el-button>
      <el-upload
        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        :show-file-list="false"
        :action="$baseUrl + 'api/uploadModelList'"
        :on-success="uploadExcelSuccess"
        :on-error="uploadExcelFailed"
        :before-upload="beforeExcelUpload"
        style="display: inline; margin-left: 10px">
        <el-button>上传</el-button>
      </el-upload>
      <el-button @click="exportData" style="margin-left: 10px">
        <a :href="exportUrl">下载模版</a>
      </el-button>
    </div>
    <el-table :data="modelList" class="table-border" v-loading="loading"
              header-cell-class-name="table-head">
      <el-table-column type="index" label="序号"></el-table-column>
      <el-table-column label="品牌名称">
        <template #default="{row}">
          <div v-loading="$isEmpty(brandMap)">{{brandMap[row.brandId]}}</div>
        </template>
      </el-table-column>
      <el-table-column label="车系名称" prop="name"></el-table-column>
      <el-table-column label="状态" width="60">
        <template #default="{row}">
          <div>{{row.status | status}}</div>
        </template>
      </el-table-column>
      <el-table-column label="备注" prop="remarks"></el-table-column>
      <el-table-column width="80" align="center">
        <template #header>
          <el-button v-if="addable" icon="el-icon-plus" type="primary" @click="add"></el-button>
        </template>
        <template #default="{row}">
          <el-button type="text" @click="edit(row)" size="mini">{{readOnly ? '查看' : '编辑'}}</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div style="text-align: center; margin-top: 10px">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="page.current"
        :page-sizes="[10, 20, 50]"
        :page-size="page.size"
        layout="sizes, total, prev, pager, next, jumper"
        :total="totalCount">
      </el-pagination>
    </div>

    <edit-model-dialog :visible.sync="dialog.show" :model="dialog.model" :read-only="readOnly"></edit-model-dialog>
  </div>
</template>

<script>
  import EditModelDialog from '@/views/car/model/EditModelDialog'
  import { Model } from '@/store/objdef/objectDef'
  import { shareDataMixin } from '@/views/mixins/ShareData'
  import authority from '@/utils/authority'

  export default {
    name: 'ModelList',
    mixins: [shareDataMixin],
    components: { EditModelDialog },
    data () {
      return {
        loading: false,
        searchText: null,
        dialog: {
          show: false,
          model: new Model()
        },
        page: {
          size: 10,
          current: 1
        }
      }
    },
    created () {
      this.loadData()
    },
    methods: {
      loadData () {
        this.loading = true
        this.$store.dispatch('model/all').finally(() => {
          this.loading = false
        })
      },
      add () {
        this.dialog.model = new Model()
        this.dialog.show = true
      },
      edit (model) {
        this.dialog.model = this.$_.cloneDeep(model)
        this.dialog.show = true
      },
      deleteModel (model) {
        this.$confirm(`确认删除车系【${model.name}】, 是否继续?`, '提示', {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$store.dispatch('model/delete', model).then(() => {
            this.$message.success('删除成功!')
          })
        }).catch(() => {
        })
      },
      exportData () {
        window.location.href = this.exportUrl
      },
      uploadExcelSuccess (res, file) {
        this.loadData()
        this.$message.success('上传成功!')
      },
      uploadExcelFailed (err) {
        this.$message.warning('上传失败!' + err)
      },
      beforeExcelUpload (file) {
        const isLt2M = file.size / 1024 / 1024 < 10
        if (!isLt2M) {
          this.$message.error('上传文件大小不能超过 10MB!')
        }
        return isLt2M
      },
      handleSizeChange (val) {
        this.page.size = val
      },
      handleCurrentChange (val) {
        this.page.current = val
      }
    },
    computed: {
      exportUrl () {
        return this.$baseUrl + 'api/downloadModelTemplate'
      },
      activeModelList () {
        const list = this.$store.state.model.modelList
        if (!this.searchText) return list

        return list.filter(model => model.name.indexOf(this.searchText) !== -1)
      },
      modelList () {
        const begIndex = this.page.size * (this.page.current - 1)
        return this.activeModelList.slice(begIndex, begIndex + this.page.size)
      },
      readOnly () {
        return !this.$hasPermission(authority.EDIT_MODEL)
      },
      addable () {
        return this.$hasPermission(authority.ADD_MODEL)
      },
      totalCount () {
        return this.activeModelList.length
      }
    }
  }
</script>

<style lang="scss" scoped>
  /deep/ th {
    height: 50px;
  }
</style>
